const TimeType = {
    Second: 1,
    Minute: 2,
    Hour: 3,
    Day: 4
};
export default TimeType;
